import axios from 'axios';
import Vue from 'vue';
import { stat } from 'fs';
import globalConstants from '@/utils/global-constants.js';


const backendBase = globalConstants.BASE_URL;

const setWindowLocalStorage = (key, value) => {
  window.localStorage.setItem(key, value);
};

const getWindowLocalStorage = (key) => window.localStorage.getItem(key);

const findCategoryAId = (name, categoryList) => {
  for (let i = 0; i < categoryList.length; i++) {
    if (categoryList[i].category_a_name === name) {
      return categoryList[i].id;
    }
  }
};

const findCategoryBId = (name, categoryAId, categoryList) => {
  for (let i = 0; i < categoryList.length; i++) {
    const categoryInfo = categoryList[i];
    if (categoryInfo.category_b_name === name && categoryInfo.category_a_id === categoryAId) {
      return categoryList[i].category_b_id;
    }
  }
};

const getCategoryAIdByName = (name, area) => {
  let categoryList = [];
  if (area === 'u.s') {
    categoryList = globalConstants.ECUS_CATEGORYA;
  } else if (area === 'academic') {
    categoryList = globalConstants.ECAD_CATEGORYA;
  } else {
    categoryList = globalConstants.ECINTER_CATEGROYA;
  }
  return findCategoryAId(name, categoryList);
};

const getCategoryBIdByName = (name, categoryAId, area) => {
  let categoryList = [];
  if (area === 'u.s') {
    categoryList = globalConstants.ECUS_CATEGORYB;
  } else if (area == 'academic') {
    categoryList = globalConstants.ECAD_CATEGORYB;
  } else {
    categoryList = globalConstants.ECINTER_CATEGROYB;
  }

  return findCategoryBId(name, categoryAId, categoryList);
};


export default {

  state: {

    tableLoading: false,
    cancelRequest: false,
    oldTableDataSet: [],
    oldTableColumns: [],
    oldChartData: {},
    tableDataSet: [],
    tableColumns: [],
    chartData: {},
    selectedTickerList: ['AAPL', 'AMZN', 'FB', 'GS', 'WMT', 'BA'],
    tagBadges: [],
    oldTerminalParamers: {},
    selectedApi: 'News by Sentiment',
    forexPairs: {
      base: '',
      targets: [],
      showBaseMenu: false,
      showTargetMenu: false,
    },
    selectedApiType: '',
    selectedApiFields: ['Sentiment', 'Title', 'Author', 'description', 'Source', 'Source Url', 'Published Time'],
    startDate: '7/24/2019',
    endDate: '7/29/2019',
    tableSearchField: 'All',

    ecIndicatorDataArea: '',
    ecIndicatorCategoryA: '',
    ecIndicatorCategoryB: '',
    ecDescription: '',
    ecUnit: '',

    indicatorSearchList: [],
    reqUrl: '',
    tickerForRecommend: '',
    recommendTickerList: [],

    notiDuration: 3000,
    loadingIndicatorName: false,

  },


  mutations: {

    changeTableLoading(state, loading) {
      state.tableLoading = loading;
    },

    cancelTerminalRequest(state, status) {
      state.cancelRequest = status;
    },

    setTableDataSet(state, dataset) {
      state.tableDataSet = dataset;
    },

    setTableColumns(state, columns) {
      state.tableColumns = columns;
    },

    setChartData(state, chartData) {
      state.chartData = chartData;
    },

    saveOldDataSet(state) {
      
      state.oldChartData = state.chartData;
      state.oldTableColumns = state.tableColumns;
      state.oldTableDataSet = state.tableDataSet;
    },

    saveOldTerminalParameters(state) {
      const { selectedApi, selectedApiType,selectedTickerList, startDate, endDate } = state;
      state.oldTerminalParamers = { selectedApi, selectedApiType,selectedTickerList, startDate, endDate };
    }, 

    restoreOldDataSet(state) {
      state.chartData = state.oldChartData;
      state.tableColumns = state.oldTableColumns;
      state.tableDataSet = state.oldTableDataSet;
    },

    setSelectedTickerList(state, tags) {
      state.selectedTickerList = tags;
      // setWindowLocalStorage('selectTickerList', tags);
    },

    setTagBadges(state, tagBadges) {
      state.tagBadges = tagBadges;
      // setWindowLocalStorage('tagBadges', tagBadges);
    },

    /**
     * method used in dropdown indicator menu
     * component for set selected apiname
     * @param {*} state
     * @param {*} apiname
     */
    setSelectedIndicatorName(state, apiname) {
      state.selectedApi = apiname;
      // setWindowLocalStorage('selectApi', apiname);
    },

    setSelectedApiType(state, type) {
      state.selectedApiType = type;
    },

    setApiSelectedFields(state, fields) {
      state.selectedApiFields = fields;
      // setWindowLocalStorage('selectApiFields', fields);
    },


    setDateRange(state, dateRange) {
      state.startDate = dateRange.startDate;
      state.endDate = dateRange.endDate;
      // setWindowLocalStorage('startDate', dateRange.startDate);
      // setWindowLocalStorage('endDate',dateRange.endDate);
    },

    setStartDate(state, date) {
      state.startDate = date;
      // setWindowLocalStorage('startDate', date);
    },

    setEndDate(state, date) {
      state.endDate = date;
      // setWindowLocalStorage('endDate',date);
    },

    setTableSearchField(state, field) {
      state.tableSearchField = field;
    },

    setBaseCurrecy(state, base) {
      state.forexPairs.base = base;
    },

    setForexPairs(state, forexPairs) {
      state.forexPairs = forexPairs;
    },

    setNotiDuration(state, duration) {
      state.notiDuration = duration;
    },

    setEcIndicatorCategoryA(state, category) {
      state.ecIndicatorCategoryA = category;
    },

    setEcIndicatorCategoryB(state, category) {
      state.ecIndicatorCategoryB = category;
    },

    setTickerForRecommend(state, ticker) {
      state.tickerForRecommend = ticker;
    },

    addTargetCurrency(state, payload) {
      const {
        base,
        target,
      } = payload;
      const {
        forexPairs,
      } = state;
      forexPairs.base = base;
      if (forexPairs.targets.includes(target)) {
        forexPairs.targets.splice(forexPairs.targets.indexOf(target), 1);
      } else {
        forexPairs.targets.push(target);
      }
    },

    setEcIndicatorDataArea(state, type) {
      state.ecIndicatorDataArea = type;
    },

    setEcIndicatorDescription(state, payload) {
      state.ecDescription = payload.description || state.ecDescription;
      state.ecUnit = payload.unit || state.ecUnit;
    },

    clearEcIndicatorDescription(state) {
      state.ecDescription = '';
      state.ecUnit = '';
    },

    setReqUrl(state, url) {
      state.reqUrl = url;
    },

    clearDateRange(state) {
      state.startDate = '';
      state.endDate = '';
    },

    clearForexPairs(state) {
      state.forexPairs = {
        base: '',
        targets: [],
        showBaseMenu: false,
        showTargetMenu: false,
      };
    },

    clearTableData(state) {
      state.tableColumns = [];
      state.tableDataSet = [];
    },

    removeSelectedField(state, field) {
      state.selectedApiFields = state.selectedApiFields.filter(el => el !== field);
      setWindowLocalStorage('selectApiFields', state.selectedApiFields);
    },

    clearIndicator(state) {
      state.selectedApi = '';
      state.selectedApiType = '';
      state.selectedApiFields = [];
    },

    clearSearchIndicator(state) {
      state.indicatorSearchList = [];
    },

    clearEcIndicators(state) {
      state.ecIndicatorDataArea = '';
      state.ecIndicatorCategoryA = '';
      state.ecIndicatorCategoryB = '';
    },

    resetTerminal(state) {
      state.selectedTickerList = [];
      state.tagBadges = [];
      state.selectedApi = '';
      state.selectedApiType = '';
      state.selectedApiFields = [];
      state.startDate = '';
      state.endDate = '';
      state.forexPairs = {
        base: '',
        targets: [],
        showBaseMenu: false,
        showTargetMenu: false,
      };
      state.ecIndicatorDataArea = '';
      state.ecIndicatorCategoryA = '';
      state.ecIndicatorCategoryB = '';
    },


    toggleForexBaseMenu(state) {
      state.forexPairs.showBaseMenu = !state.forexPairs.showBaseMenu;
    },

    closeForexBaseMenu(state) {
      state.forexPairs.showBaseMenu = false;
    },

    toggleForexTargetMenu(state, base) {
      if (base !== state.forexPairs.base) {
        state.forexPairs.showTargetMenu = true;
      } else {
        state.forexPairs.showTargetMenu = !state.forexPairs.showTargetMenu;
      }
    },

  },


  actions: {

    /**
     *
     * Description. used in dropdown indicator menu
     * component for selected apiname corresponding fields array
     * @param {*} param0
     * @param { Array } selectedApiFieldsArray
     * Array of objects eg {fields: "", selected: true}
     * for select api.
     */
    getApiSelectedFields({
      commit,
    }, selectedApiFieldsArray) {
      const selectedApiFields = selectedApiFieldsArray
        .filter(el => el.selected)
        .map(el => el.field);

      commit('setApiSelectedFields', selectedApiFields);
    },

    getLocalData({
      commit,
      state,
    }) {

      const apiname = getWindowLocalStorage('selectApi');

      if (apiname) {
        commit('setSelectedIndicatorName', apiname);
      }

      const apiType = getWindowLocalStorage('selectApiType');

      if (apiType) {
        commit('setSelectedApiType', apiType);
      }

      const fields = getWindowLocalStorage('selectApiFields');

      if (fields) {
        commit('setApiSelectedFields', fields.split(','));
      }

      const startDate = getWindowLocalStorage('startDate');
      const endDate = getWindowLocalStorage('endDate');

      // set dateRange in local
      if (startDate && endDate) {
        commit('setDateRange', {
          startDate,
          endDate,
        });
      }


      const tickerListStr = getWindowLocalStorage('selectTickerList');
      // console.log('ticker list in str' , tickerListStr);
      if (!tickerListStr) return;
      // check if user choose ecnomic indicator
      if (tickerListStr.includes('Data:')) {
        commit('setSelectedTickerList', [tickerListStr]);
        commit('setEcIndicatorDataArea', tickerListStr.split(':')[0].trim());
        commit('setEcIndicatorCategoryA', tickerListStr.split(':')[1].trim());
        // category B store as apiType in local storage
        commit('setEcIndicatorCategoryB', apiType);
        // set set api fields to empty if api is economic indicator
        commit('setApiSelectedFields', []);

      }
      // if there is forex pair in local.
      else if (tickerListStr.charAt(3) === '-') {
        const tickerlist = tickerListStr.split(',');
        const base = tickerlist[0].split('-')[0];
        const targets = tickerlist.map(pair => pair.split('-')[1]);
        state.forexPairs = {
          base,
          targets,
          showBaseMenu: false,
          showTargetMenu: false,
        };
        commit('setSelectedTickerList', tickerlist);
      } else {
        commit('setSelectedTickerList', tickerListStr ? tickerListStr.split(',') : []);
      }

    },

    setPriorDate({ commit }, days) {
      const date = new Date(new Date().setDate(new Date().getDate() - days));
      let startDate;
      if (days === 'YTD') {
        startDate = new Date(new Date().getFullYear(), 0, 1).toLocaleDateString('US');
      }
      else startDate = date.toLocaleDateString('US');
      const endDate = new Date().toLocaleDateString('US');
      commit('setDateRange', { startDate, endDate });
    },

    fetchTerminalData({
      commit,
      state,
    }, payload) {
      return fetch(`${backendBase}terminal?${payload.reqUrl}`, {
        method: 'Get',
        headers: {
          Authorization: payload.token,
        },
      });
    },

    elaticSearchForAssets({
      commit,
      state,
    }, input) {
      return fetch(`${backendBase}es/${input}`);
    },

    searchEcIndicators({
      commit,
      state,
    }, payload) {
      const {
        ecIndicatorNameSearch,
        ecIndicatorDataArea,
        ecIndicatorCategoryA,
        ecIndicatorCategoryB,
      } = payload;
      const area = ecIndicatorDataArea.split(' ')[0].toLowerCase();
      const categoryAId = getCategoryAIdByName(ecIndicatorCategoryA, area);
      const categoryBId = getCategoryBIdByName(ecIndicatorCategoryB, categoryAId, area);
      console.log(categoryAId, categoryBId);
      if (!ecIndicatorNameSearch && state.indicatorSearchList.length === 0) {
        state.loadingIndicatorName = true;
      }
      axios.get(`${backendBase}esecon/indicator?indicatoname=${ecIndicatorNameSearch}&tableName=${area}&categoryAId=${categoryAId}&categoryBId=${categoryBId}`)
        .then((res) => {
          // console.log(res.data);
          const resultSet = new Set(res.data.map(el => el.indicatorName));
          state.indicatorSearchList = [...resultSet];
          state.loadingIndicatorName = false;
        })
        .catch((err) => {
          console.log(err);
          state.indicatorSearchList = [];
        });
    },

    notify({
      commit,
      state,
    }, payload) {
      const {
        info,
        type,
      } = payload;
      const duration = type === 'success' ? 3000 : 5000;
      state.notiDuration = duration;
      Vue.notify({
        group: 'note',
        text: info,
        type,
      });
    },

    getRecommendTickerList({ commit, state }) {
      axios.get(`${backendBase}user/recommendations?ticker=${state.tickerForRecommend}`)
        .then((res) => {
          const { recommendationList } = res.data;
          state.recommendTickerList = recommendationList ? recommendationList.split(',') : [];
        });
    },

  },

  getters: {

    startDate(state) {
      return state.startDate;
    },

    endDate(state) {
      return state.endDate;
    },

    tableSearchField(state) {
      return state.tableSearchField;
    },
    selectedApiFields(state) {
      return state.selectedApiFields;
    },
  },


};



// WEBPACK FOOTER //
// ./src/store/terminal-service.js